import logo from "@/assets/icon-192.png";

const Header = () => {
  return (
    <header className="fixed top-0 left-0 right-0 bg-background/90 backdrop-blur-sm z-50 border-b border-border/40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex-shrink-0 flex items-center">
            <img 
              src={logo} 
              alt="Zuto Logo" 
              className="h-8 w-8 mr-2 object-contain"
            />
            <span className="font-bold text-xl">Zuto</span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
